(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spingo-heat-v2"] && !Shopify.designMode) return;
  try {
    
  function moveHeatCarousel(button, direction) {
    const carousel = button.closest('[data-sg-heat-carousel]');
    const track = carousel && carousel.querySelector('[data-sg-heat-track]');
    const slides = track ? Array.from(track.querySelectorAll('[data-sg-heat-slide]')) : [];
    if (!track || slides.length < 2) return;

    let currentIndex = 0;
    let shortestDistance = Infinity;
    slides.forEach(function (slide, index) {
      const distance = Math.abs(slide.offsetLeft - track.scrollLeft);
      if (distance < shortestDistance) {
        shortestDistance = distance;
        currentIndex = index;
      }
    });

    const nextIndex = (currentIndex + direction + slides.length) % slides.length;
    track.scrollTo({ left: slides[nextIndex].offsetLeft, behavior: 'smooth' });
  }

  document.addEventListener('click', function (event) {
    const previousButton = event.target.closest('[data-sg-heat-prev]');
    const nextButton = event.target.closest('[data-sg-heat-next]');
    if (previousButton || nextButton) {
      moveHeatCarousel(previousButton || nextButton, previousButton ? -1 : 1);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spingo-mix-v2"] && !Shopify.designMode) return;
  try {
    
  function moveMixV2Carousel(button, direction) {
    const carousel = button.closest('[data-sg-v2-carousel]');
    const track = carousel && carousel.querySelector('[data-sg-v2-track]');
    const slides = track ? Array.from(track.querySelectorAll('[data-sg-v2-slide]')) : [];
    if (!track || slides.length < 2) return;

    let currentIndex = 0;
    let shortestDistance = Infinity;
    slides.forEach(function (slide, index) {
      const distance = Math.abs(slide.offsetLeft - track.scrollLeft);
      if (distance < shortestDistance) {
        shortestDistance = distance;
        currentIndex = index;
      }
    });

    const nextIndex = (currentIndex + direction + slides.length) % slides.length;
    track.scrollTo({ left: slides[nextIndex].offsetLeft, behavior: 'smooth' });
  }

  document.addEventListener('click', function (event) {
    const previousButton = event.target.closest('[data-sg-v2-prev]');
    const nextButton = event.target.closest('[data-sg-v2-next]');
    if (previousButton || nextButton) {
      moveMixV2Carousel(previousButton || nextButton, previousButton ? -1 : 1);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
